var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"split-layout w-100 h-100 p-0",attrs:{"fluid":""}},[_c('div',{staticClass:"split__left justify-content-center align-items-center"},[_vm._t("left"),(!_vm.hasSlot('left'))?[_c('custom-carousel',{staticClass:"split-layout__carousel",attrs:{"slides":[
          {
            title: 'How It Works',
            desc:
              'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do',
            image: require('@/assets/images/board-lg.svg')
          },
          {
            title: 'Find a Tool',
            desc: "Search for the tool you're looking for using the search bar",
            image: require('@/assets/images/search-lg.svg')
          },
          {
            title: 'Select Dates',
            desc: "Select the amount of days you'd like to rent your tool",
            image: require('@/assets/images/calendar-lg.svg')
          },
          {
            title: 'Checkout',
            desc: 'Review your information and go for an easy checkout',
            image: require('@/assets/images/checkout-lg.svg')
          }
        ]}})]:_vm._e()],2),_c('div',{staticClass:"split__right justify-content-center align-items-center"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }